import { Banner, Heading, Text } from 'components/chroma';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import ICONS from 'components/Icons';
import {
  colesContactCenter,
  customerCareNumber,
  format1300Number,
  insuranceBaseUrl,
} from 'scenes/common/helpers/contacts';
import { SCREEN } from 'scenes/common/types/screen';
import { OutageState } from 'scenes/outage/types';
import { isCCMaintenance } from 'scenes/common/selectors/configSelectors';

const PageWrapper = styled.div`
  margin-top: 30px;

  @media (min-width: ${SCREEN.SMALL}px) {
    margin-top: 60px;
  }
`;

const MaintenanceImage = styled.img`
  height: 8rem;
  width: 100%;
  position: relative;
  z-index: 2;
  top: -14px;

  @media (min-width: ${SCREEN.SMALL}px) {
    height: 14rem;
    top: 48px;
  }
`;

export const Wrapper: FunctionComponent = ({ children }) => (
  <PageWrapper>{children}</PageWrapper>
);

export const PageText: FunctionComponent<{
  onClickCallUs?: () => void;
  isAlternativelyMsgBold?: boolean;
}> = ({ onClickCallUs, isAlternativelyMsgBold = true }) => (
  <>
    <Text>We apologise for the inconvenience, please try again later.</Text>
    <Text>
      {(isAlternativelyMsgBold && (
        <strong>Alternatively you can call us on </strong>
      )) || <>Alternatively you can call us on </>}
      <a onClick={onClickCallUs} href={`tel:${customerCareNumber()}`}>
        {format1300Number(customerCareNumber())}
      </a>
    </Text>
    <Text>
      Our contact hours can be found{' '}
      <a href={colesContactCenter()} target="_blank" rel="noopener noreferrer">
        here
      </a>
      .
    </Text>

    <Text>
      Return to the{' '}
      <a href={insuranceBaseUrl()} target="_blank" rel="noopener noreferrer">
        Coles Insurance home page
      </a>
    </Text>
  </>
);

const CCOutage: FunctionComponent<{ onClickCallUs: () => void }> = ({
  onClickCallUs,
}) => (
  <>
    <Text>
      Between Saturday 17th June at 4pm AEST and Sunday 18th of June AEST, we
      are conducting a system upgrade.
    </Text>
    <Text>
      During this period, you won&apos;t be able to purchase a new policy, make
      any payments, and amend or cancel an existing policy on our website or
      call centre.
    </Text>
    <Text>
      You&apos;ll still be able to lodge a claim or get roadside assistance by
      calling us on{' '}
      <a onClick={onClickCallUs} href={`tel:${customerCareNumber()}`}>
        {format1300Number(customerCareNumber())}
      </a>
      .
    </Text>
    <Text>
      We apologise for any inconvenience and appreciate your understanding.
    </Text>
  </>
);

export const ScheduledMaintenance: FunctionComponent<{
  onClickCallUs: () => void;
  funnelState: OutageState;
}> = ({ onClickCallUs, funnelState }) => (
  <>
    <Banner width="viewport" padding={0}>
      <MaintenanceImage
        src={ICONS.ERROR.MAINTENANCE}
        tabIndex={-1}
        alt="Laptop with Coles logo graphic"
      />
    </Banner>

    <Wrapper>
      <Heading>
        We&#39;re sorry but this service is temporarily unavailable.
      </Heading>
      {isCCMaintenance(funnelState.apiResponses.config) ? (
        <CCOutage onClickCallUs={onClickCallUs} />
      ) : (
        <PageText onClickCallUs={onClickCallUs} />
      )}
    </Wrapper>
  </>
);
